const cs = require('crypto-js');

exports.encrypt = async (key, text) => {
  try {
     
   
  
    const encryptedText = await cs.AES.encrypt(text,key).toString();
    return encryptedText;
  } catch (error) {
      console.log(error)
    return null;
  }
};

exports.decrypt = async (key, text) => {
    try {
       

      const encryptedText = await cs.AES.decrypt(text,key);
      var originalText = JSON.parse(encryptedText.toString(cs.enc.Utf8));

      return originalText;
    } catch (error) {

        console.log(error)
        throw error;
      return null;
    }
  };


